import { date2ts } from './date'

export const formatParams = (searchFormData = {}, extraParams = {}) => {
  const params = {}
  const keys = Object.keys(searchFormData)

  keys.forEach(key => {
    let value = searchFormData[key]

    if (typeof value === 'string') value = value.trim()
    if (value !== undefined && value !== '' && value !== null) {
      params[key] = value
    }
    if (value instanceof Date) {
      params[key] = date2ts(value)
    }
    if (
      Array.isArray(value)
      && value.reduce((prev, cur) => prev && cur instanceof Date, true)
    ) {
      params[key] = `${date2ts(value[0])},${date2ts(value[1])}`
    }
  })

  if (extraParams.page) {
    params.page = extraParams.page
  }
  if (extraParams.size) {
    params.count = extraParams.size
  }
  return params
}



// WEBPACK FOOTER //
// ./packages/utils/params.js